/*
 * @description: 
 * @Author: HaoJG
 * @Date: 2021-08-09 10:48:34
 * @Lasteditors: HaoJG
 * @LastEditTime: 2022-04-09 15:41:32
 */
const whiteList = [
    '/login',
    '/wxlogin',
    '/mobile'
]

export default whiteList